var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.visible && _vm.visible == true) || _vm.visible == undefined)?_c('span',{staticClass:"button is-info is-light is-small is-outline is-rounded"},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }